export const load = () => ({
	title: 'Why We Use Acrylic vs. Glass',
	showTitle: true,
});
